var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Typography } from '@telus-uds/components-web';
import isEmpty from 'lodash/isEmpty';
import { contentfulReplaceTagsRichText, getParagraphSize, isRichTextEmpty } from '../../helpers/richText';
import { RICH_TEXT_TYPES } from '../../types';
import { buildEmbeddedAsset } from './embeddedAsset';
import { buildEmbeddedInlineEntryFunction } from './embeddedInlineEntries';
import { buildHeadingFunctions } from './headings';
import { buildHyperlinkFunctions } from './hyperlinks';
import { buildListFunctions } from './lists';
import { buildParagraphFunction } from './paragraph';
var MARKS = RICH_TEXT_TYPES.MARKS;
export var RichText = function (_a) {
    var _b;
    var _c;
    var _content = _a.content, color = _a.color, listOptions = _a.listOptions, _d = _a.renderChevronLink, renderChevronLink = _d === void 0 ? false : _d, renderTextButton = _a.renderTextButton, EmbeddedInlineComponent = _a.EmbeddedInlineComponent, _e = _a.linkOptions, linkOptions = _e === void 0 ? { variant: { inverse: false, alternative: false } } : _e, paragraphSize = _a.paragraphSize, headingSize = _a.headingSize, _f = _a.tokensMap, tokensMap = _f === void 0 ? null : _f, DrawerLinkComponent = _a.DrawerLinkComponent, _g = _a.alignText, alignText = _g === void 0 ? 'left' : _g, _h = _a.openLinksInNewTab, openLinksInNewTab = _h === void 0 ? false : _h, _j = _a.linesBetween, linesBetween = _j === void 0 ? 1 : _j, _k = _a.typographyBlock, typographyBlock = _k === void 0 ? true : _k;
    if (isEmpty(_content) || isRichTextEmpty(_content))
        return null;
    var _l = color !== null && color !== void 0 ? color : {}, paragraph = _l.paragraph, strong = _l.strong, heading = _l.heading, link = _l.link, embeddedInline = _l.embeddedInline;
    var contentJson = (_c = _content.json) !== null && _c !== void 0 ? _c : _content;
    // replace tokens in richtext data if tokensMap is provided
    var content = tokensMap ? contentfulReplaceTagsRichText(contentJson, tokensMap) : contentJson;
    var headingProps = { heading: heading, alignText: alignText, headingSize: headingSize };
    var paragraphProps = {
        content: content,
        listOptions: listOptions,
        paragraphSize: paragraphSize,
        alignText: alignText,
        linesBetween: linesBetween,
        EmbeddedInlineComponent: EmbeddedInlineComponent,
        paragraph: paragraph,
        embeddedInline: embeddedInline,
        typographyBlock: typographyBlock
    };
    var hyperlinkProps = {
        renderChevronLink: renderChevronLink,
        openLinksInNewTab: openLinksInNewTab,
        linkOptions: linkOptions,
        DrawerLinkComponent: DrawerLinkComponent,
        renderTextButton: renderTextButton,
        link: link
    };
    var embeddedInlineEntryProps = {
        EmbeddedInlineComponent: EmbeddedInlineComponent,
        content: content,
        legalSizing: { headingSize: headingSize, paragraphSize: paragraphSize }
    };
    // build functions for each type of node to render
    var headingFunctions = buildHeadingFunctions(headingProps);
    var paragraphFunction = buildParagraphFunction(paragraphProps);
    var listFunctions = buildListFunctions(listOptions);
    var embeddedAssetFunction = buildEmbeddedAsset();
    var hyperlinkFunction = buildHyperlinkFunctions(hyperlinkProps);
    var embeddedInlineEntryFunction = buildEmbeddedInlineEntryFunction(embeddedInlineEntryProps);
    var options = {
        renderMark: (_b = {},
            _b[MARKS.BOLD] = function (texts) {
                var resolvedParagraphSize = getParagraphSize(content, texts, paragraphSize, listOptions);
                return (_jsx(Typography, { variant: __assign({ colour: strong, bold: true }, (resolvedParagraphSize && { size: resolvedParagraphSize })), tag: "strong", children: texts }));
            },
            _b),
        renderNode: __assign(__assign(__assign(__assign(__assign(__assign({}, paragraphFunction), headingFunctions), listFunctions), embeddedAssetFunction), hyperlinkFunction), embeddedInlineEntryFunction)
    };
    return content && documentToReactComponents(content, options);
};
export default RichText;
